export function flattenTree(tree, flatList = [], condition) {
    var _a;
    // save leaf node
    if (!((_a = tree.children) === null || _a === void 0 ? void 0 : _a.length)) {
        const shouldInclude = !condition ||
            condition({ child: tree, isLeafNode: true, hasValidLeafNode: false });
        if (shouldInclude) {
            flatList.unshift(tree);
        }
        return shouldInclude;
    }
    let hasValidLeafNode = false;
    for (const child of tree.children) {
        if (flattenTree(child, flatList, condition)) {
            hasValidLeafNode = true;
        }
    }
    // save parent
    const shouldInclude = condition
        ? condition({ child: tree, isLeafNode: false, hasValidLeafNode })
        : hasValidLeafNode;
    if (shouldInclude) {
        flatList.unshift(tree);
    }
    return shouldInclude;
}
//# sourceMappingURL=flattenTree.js.map